import { render } from "./UsinLayout.vue?vue&type=template&id=0d6531a6&ts=true"
import script from "./UsinLayout.vue?vue&type=script&lang=ts"
export * from "./UsinLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__